import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BrandMark } from './BrandMark';
import { FoundingFooter } from './FoundingFooter';
import '../LandingPageV2.css';
import './FoundingMemberPage.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { document.title = 'SchedulesOfWork | Unsubscribe'; }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await axios.post(`${API}/waitlist/unsubscribe`, { email: email.trim() });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="landing-v2 fm-page fm-tester-page">
      <header className="lv2-nav"><div className="lv2-nav-inner"><BrandMark /></div></header>
      <main className="fm-tester-main">
        <div className="fm-tester-card" data-testid="unsubscribe-card">
          <h1 className="fm-tester-h1">Unsubscribe</h1>
          {done ? (
            <p className="fm-unsub-p" data-testid="unsubscribe-done">You've been unsubscribed. We won't email you about SchedulesOfWork again.</p>
          ) : (
            <form onSubmit={submit} data-testid="unsubscribe-form">
              <p className="fm-unsub-p">Enter the email you joined with and we'll stop sending you emails.</p>
              <label className="fm-label" htmlFor="unsub-email">Email address</label>
              <input id="unsub-email" type="email" className="fm-input" value={email} onChange={(e) => setEmail(e.target.value)}
                required autoComplete="email" data-testid="unsubscribe-email-input" />
              {error && <div className="fm-error" role="alert" data-testid="unsubscribe-error">{error}</div>}
              <button type="submit" className="fm-btn-primary fm-btn-block" disabled={busy} data-testid="unsubscribe-submit-btn">
                {busy ? 'Unsubscribing…' : 'Unsubscribe'}
              </button>
            </form>
          )}
          <Link to="/" className="fm-back-link" data-testid="unsubscribe-back-link">Back to home</Link>
        </div>
      </main>
      <FoundingFooter />
    </div>
  );
}
